<mat-progress-bar mode="{{mode}}" value="{{value}}" ngClass="{{className}}" ></mat-progress-bar>
